import React from 'react';
import PropTypes from 'prop-types';

const ApiIcon = ({ className }) => {
    return (
        <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.97222 14.5278C4.75 16.3056 7.19444 15.1944 7.86111 14.5278L9.19444 13.1944L4.30556 8.30556L2.97222 9.63889C2.30556 10.3056 1.19444 12.75 2.97222 14.5278ZM2.97222 14.5278L0.75 16.75M14.5278 2.97222C12.75 1.19444 10.3056 2.30556 9.63889 2.97222L8.30556 4.30556L13.1944 9.19444L14.5278 7.86111C15.1944 7.19444 16.3056 4.75 14.5278 2.97222ZM14.5278 2.97222L16.75 0.75M9.19444 5.19444L7.41667 6.97222M12.3056 8.30556L10.5278 10.0833" stroke="#228EBC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
};

ApiIcon.propTypes = {
    className: PropTypes.string
};

export default ApiIcon
